import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "./axiosBaseQuery";

const baseSearchApi = '/search/api';
const baseCmsApi = '/api/website/2.0'


export const searchApi = createApi({
    reducerPath: 'searchApi',
    baseQuery: axiosBaseQuery({}),
    tagTypes: ['search'],
    endpoints: (build) => ({
        search: build.query({
            query: (params) => ({
                url: baseSearchApi + '/',
                params
            })
        }),
        getSearchFilters: build.query({
            query: ({fields, filters}) => ({
                url: baseSearchApi + '/benefits/',
                params: {fields, filters, size: 1}
            }),
            transformResponse(baseQueryReturnValue ) {
                const filters = baseQueryReturnValue.benefits.metadata.filters
                return filters.reduce((agg, f) => {
                    agg[f.inputName] = f.values
                    return agg
                }, {})
            }
        }),
        searchBenefits: build.query({
            query: (params) => ({
                url: baseSearchApi + '/benefits/',
                params
            })
        }),
        searchArticles: build.query({
            query: (params) => ({
                url: baseSearchApi + '/articles/',
                params
            })
        }),
        searchCategoryBenefits: build.query({
            query: (params) => ({
                url: baseCmsApi + '/getCategoryBenefits/',
                params
            })
        }),
        getAllBenefits: build.query({
            query: (params) => ({
                url: baseCmsApi + '/getAllBenefits/',
                params
            })
        }),
        getSelectedBenefits: build.query({
            query: (params) => {
                return ({
                    url: baseSearchApi + '/selected-benefits/',
                    params
                })
            },
            transformErrorResponse(baseQueryReturnValue, meta, arg) {
                return []
            }
        })

    })
})


export const {
    useGetAllBenefitsQuery,
    useSearchQuery,
    useSearchBenefitsQuery,
    useSearchArticlesQuery,
    useSearchCategoryBenefitsQuery,
    useGetSearchFiltersQuery,
    useGetSelectedBenefitsQuery,
} = searchApi
